
export const ReimbursementStep = {
  ADD_DETAILS: 'ADD_DETAILS',
  CAPTURE_IMAGES: 'CAPTURE_IMAGES',
  CHOOSE_PURSE: 'CHOOSE_PURSE',
  SELECT_CATEGORIES: 'SELECT_CATEGORIES',
  REVIEW: 'REVIEW',
  ALLOCATE_CATEGORIES: 'ALLOCATE_CATEGORIES',
  COMPLETE: 'COMPLETE'
} as const;
// Type for type safety (optional but recommended)

export type ReimbursementStep = (typeof ReimbursementStep)[keyof typeof ReimbursementStep];
